import React, { useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { SText } from 'src/components/SText';
import { AllowedPhoneCountries, AllowedPhoneCountriesList } from 'src/consts';
import { FormsErrorParser } from 'src/containers/errors';
import { $colors } from 'src/theme';

export type PhoneWithPrefixInputProps = {
  testID?: string;
  onChange: (value: string, fullPhone: string) => void;
  value: string | null | undefined;
  error?: FieldError | undefined;
  placeholder: string;
  onBlur: () => void;
  label?: string;
  showUpLabel?: boolean;
  smallTitle?: boolean;
  copyNumbersOnly?: boolean;
  country?: (typeof AllowedPhoneCountries)[number];
};

export const PhoneWithPrefixInput: React.FC<PhoneWithPrefixInputProps> = ({
  country,
  onBlur,
  placeholder,
  error,
  value,
  label,
  showUpLabel = false,
  copyNumbersOnly = true,
  onChange,
  smallTitle,
}) => {
  const { t } = useTranslation();
  const classes = error ? '' : '';
  const inputStyle = error ? { borderColor: $colors.error } : { borderColor: $colors.gray400 };

  const onChangeHandler = useCallback(
    (val, data) => {
      onChange(val, `+${data.dialCode}${val}`);
    },
    [onChange],
  );

  return (
    <div>
      {showUpLabel && (
        <SText
          classNames={`block ${
            smallTitle ? 'text-md' : 'text-xl'
          } text-primary font-semibold my-1 text-left flex w-full`}
          label={label ?? placeholder ?? ''}
        />
      )}
      <PhoneInput
        onlyCountries={AllowedPhoneCountriesList}
        value={value}
        country={country}
        onChange={onChangeHandler}
        containerClass={`${classes} w-full`}
        placeholder={t(placeholder)}
        onBlur={onBlur}
        autoFormat={false}
        copyNumbersOnly={copyNumbersOnly}
        inputClass="w-full py-2 text-gray-500 focus-within:text-gray-600  md:shadow-sc drop-shadow-s font-light  placeholder-gray-300 text-lg"
        inputStyle={{ height: 42, width: '100%', fontSize: '16px', ...inputStyle }}
      />
      <FormsErrorParser error={error} />
    </div>
  );
};
